"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OVERLAY_VIEW;
(function (OVERLAY_VIEW) {
    OVERLAY_VIEW["tone"] = "tone";
    OVERLAY_VIEW["soft"] = "soft";
    OVERLAY_VIEW["ghost"] = "ghost";
})(OVERLAY_VIEW = exports.OVERLAY_VIEW || (exports.OVERLAY_VIEW = {}));
var OVERLAY_CONTENT_MOD;
(function (OVERLAY_CONTENT_MOD) {
    OVERLAY_CONTENT_MOD["top"] = "top";
    OVERLAY_CONTENT_MOD["right"] = "right";
    OVERLAY_CONTENT_MOD["bottom"] = "bottom";
    OVERLAY_CONTENT_MOD["left"] = "left";
    OVERLAY_CONTENT_MOD["center"] = "center";
    OVERLAY_CONTENT_MOD["fill"] = "fill";
})(OVERLAY_CONTENT_MOD = exports.OVERLAY_CONTENT_MOD || (exports.OVERLAY_CONTENT_MOD = {}));
//# sourceMappingURL=types.js.map